// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"style_leftButton__2pKij","rightButton":"style_rightButton__1mRx0"};